import { Heading_3 as Heading3, useThemeContext } from '@huggg/react-components';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { EmojiControl } from '../EmojiControl';
import { MessageBubble } from '../MessageBubble';
import styles from './reactable-message.module.scss';

export const ReactableMessage = ({
  animate = true,
  emoji,
  error = '',
  loading = false,
  message = '',
  onAnimationComplete,
  onEmojiReaction,
  reactionDisabled = false,
  senderName = '',
  title,
}) => {
  const [animationPhase, setAnimationPhase] = useState(0);
  const [hasPickedEmoji, setHasPickedEmoji] = useState(Boolean(emoji));

  useEffect(() => {
    setHasPickedEmoji(Boolean(emoji));
  }, [emoji]);

  useEffect(() => {
    if (animationPhase === 1) {
      const timer = setTimeout(() => {
        onAnimationComplete && onAnimationComplete();
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [animationPhase, onAnimationComplete]);

  const hasFinishedAnimation = !animate || !message || animationPhase === 1;

  const onEmojiSelected = selectedEmoji => {
    onEmojiReaction(selectedEmoji);
  };

  const {
    reaction: { enabled: themeEnabled }
  } = useThemeContext();

  const enabled = themeEnabled && !reactionDisabled;

  return (
    <div>
      <Heading3 className={styles.title}>{title}</Heading3>
      <div
        className={classnames(styles.container, {
          [styles.withMessage]: enabled && message,
          [styles.reactedWithNoMessage]: !message && hasPickedEmoji,
          [styles.margins]: enabled && !message,
        })}
      >
        {message && (
          <MessageBubble
            message={message}
            animate={animate}
            onAnimationComplete={() => setAnimationPhase(1)}
            extraHeight={hasFinishedAnimation && enabled ? '20px' : '0px'}
          />
        )}
        {enabled && (
          <div
            className={classnames(styles.control, {
              [styles.showControl]: hasFinishedAnimation,
              [styles.offset]: Boolean(message)
            })}
          >
            {hasFinishedAnimation && (
              <EmojiControl
                loading={loading}
                value={emoji}
                onEmojiSelected={onEmojiSelected}
                onEmojiEdit={() => setHasPickedEmoji(false)}
                sender={senderName}
                solo={!message}
                error={error}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};
